module.exports = __webpack_public_path__ + "static/img/05.b931bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/05.jpg
// module id = FsjL
// module chunks = 3